import { render, staticRenderFns } from "./CrmPaymentsTable.vue?vue&type=template&id=1e108256&scoped=true&"
import script from "./CrmPaymentsTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CrmPaymentsTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CrmPaymentsTable.vue?vue&type=style&index=0&id=1e108256&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e108256",
  null
  
)

export default component.exports